module.exports = __webpack_public_path__ + "static/media/productTypePF.406457f9.svg";